// converts array of data in JSON format to an excel file

import { fetchData } from "./fetchData";

// returns a blob that is downloadable
export const exportExcel = async (data, columnNameMap, route, JobID) => {

    const url = `/${route}/export/`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({[`${route}Data`]: data, columnNameMap, JobID})
    }

    //fetchData with asBlob=true already returns the blob (or a structured error object)
    let response = await fetchData(url, options, true);
    return response;
}